var acc = document.getElementsByClassName("accordion");

for (let i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    var panel = this.nextElementSibling;

    // Toggle current one only
    if (this.classList.contains("active")) {
      this.classList.remove("active");
      panel.style.maxHeight = null;
    } else {
      this.classList.add("active");
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

// Adjust child accordions to not collapse parent max-height
var acc_child = document.querySelectorAll(".child-accordions .accordion");

acc_child.forEach(el => {
  el.addEventListener("click", () => {
    const panel = el.closest(".panel");
    panel.style.maxHeight = "fit-content";
    el.closest(".panel").previousElementSibling.classList.add("active");

    setTimeout(() => {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }, 400);
  });
});